import React from "react";
import { Fonts, FontColors } from "theme/fontConfig";

export const MyCheckboxRenewal = ({
  id,
  title,
  checked,
  name,
  onChange,
  disabled = false,
  ...props
}) => {
  const checkboxId = id || `checkbox-${name}`;

  return (
    <div
      className="d-flex"
      style={{
        alignItems: "center",
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <label
        className={`checkbox checkbox-sm checkbox-single ${
          disabled ? "disabled-checkbox" : ""
        }`}
        style={props.style}
        htmlFor={checkboxId}
      >
        <input
          id={checkboxId}
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          style={{
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        />
        <span />
      </label>

      {title && (
        <label
          htmlFor={checkboxId}
          style={{
            marginBottom: 0,
            marginLeft: 10,
            ...Fonts.GeneralSubHeaderFont,
            color: FontColors.Slate1E293B,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          {title}
        </label>
      )}
    </div>
  );
};
